<template>
  <div class="grow-up-container">
    <div class="page-content">
      <div class="operation-bar">
        <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleCreate">新增</el-button>
        <el-button type="danger" size="mini" @click="handleBatchDelete" :disabled="!selectedRows.length"
          >删除</el-button
        >
        <div class="search-box">
          <!-- <span style="margin-right: 10px; color: #fff;">所属大棚</span>
                    <el-select v-model="greenhouseId" placeholder="请选择" style="width: 200px;" size="mini" clearable>
                        <el-option v-for="item in greenhouseOptions" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <span style="margin: 0 10px; color: #fff;">草莓品种</span>
                    <el-select v-model="varietyId" placeholder="请选择" style="width: 200px;" size="mini" clearable>
                        <el-option v-for="item in varietyOptions" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select> -->
          <span style="margin: 0 10px; color: #fff">当前时期</span>
          <el-select v-model="basicStageId" placeholder="请选择" style="width: 200px" size="mini" clearable>
            <el-option v-for="item in stageOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button icon="el-icon-search" style="margin-left: 10px" size="mini" type="primary" @click="handleSearch"
            >查询</el-button
          >
        </div>
      </div>
      <el-table :data="tableData" border style="width: 100%" height="60vh" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="序号" type="index" width="80" align="center"> </el-table-column>
        <el-table-column prop="greenhouseName" label="大棚编号"></el-table-column>
        <el-table-column prop="varietyName" label="草莓品种"></el-table-column>
        <el-table-column prop="growthPeriod" label="生长时期">
          <template slot-scope="scope">
            <span
              >{{ scope.row.cycleStartDate.replace(/-/g, '/') }} - {{ scope.row.cycleEndDate.replace(/-/g, '/') }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="各时期时间段">
          <template slot-scope="scope">
            <div v-for="detail in scope.row.details" :key="detail.id" style="margin-bottom: 5px">
              {{ detail.basicStageName }}: &nbsp;{{ detail.startDate.replace(/-/g, '/') }}-{{
                detail.endDate.replace(/-/g, '/')
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间">
          <template slot-scope="scope">
            {{ formatTime(scope.row.updateTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" style="color: #2680dd" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" style="color: #04ff9f" @click="handleView(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 新增/编辑弹窗 -->
    <GrowUpDialog
      :visible.sync="dialogVisible"
      :is-edit="isEdit"
      :edit-data="formData"
      @success="handleDialogSuccess"
      @close="handleDialogClose"
    />

    <!-- 查看详情弹窗 -->
    <el-dialog title="查看详情" :visible.sync="viewDialogVisible" width="72vw">
      <div class="view-dialog-content">
        <!-- 顶部筛选栏 -->
        <div class="filter-section">
          <div class="filter-item">
            <span class="filter-label">所属大棚</span>
            <el-select v-model="viewRow.greenhouseId" placeholder="暂无数据" style="width: 200px" size="mini" disabled>
              <el-option v-for="item in greenhouseOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">草莓品种</span>
            <el-select v-model="viewRow.varietyId" placeholder="暂无数据" style="width: 200px" size="mini" disabled>
              <el-option v-for="item in varietyOptionsDia" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>

        <!-- 详细时期配置表格 -->
        <div class="config-table">
          <el-table :data="viewRow.details || []" border style="width: 100%" size="mini">
            <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
            <el-table-column label="时期名称" width="200">
              <template slot-scope="scope">
                <span>{{ scope.row.basicStageName || '根据品种带出' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="判定标准">
              <template slot-scope="scope">
                <span>{{ scope.row.judgmentCriteria || '根据时期带出' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="注意事项">
              <template slot-scope="scope">
                <span>{{ scope.row.precautions || '根据时期带出' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="该时期天数(天)" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.days || 0 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="具体日期时段">
              <template slot-scope="scope">
                <span v-if="scope.row.startDate && scope.row.endDate" style="color: #409eff">
                  {{ scope.row.startDate.replace(/-/g, '/') }} - {{ scope.row.endDate.replace(/-/g, '/') }}
                </span>
                <span v-else style="color: #999">暂无数据</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 状态信息 -->
        <div class="status-info">
          <span class="status-label">状态:</span>
          <span class="status-value">{{ viewRow.enabled === 1 ? '启用' : '禁用' }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="viewDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/axios';
import { baseUrl } from '@/axios/baseUrl';
import GrowUpDialog from './GrowUpDialog.vue';
import { mapState } from 'vuex';
export default {
  name: 'GrowUpManagement',
  components: {
    GrowUpDialog,
  },
  data() {
    return {
      tableData: [],
      selectedRows: [],
      greenhouseId: '',
      varietyId: '',
      basicStageId: '',
      page: 1,
      pageSize: 10,
      totalCount: 0,
      dialogVisible: false,
      formData: {
        id: '',
        greenhouseId: '',
        greenhouseName: '',
        varietyId: '',
        varietyName: '',
        details: [],
        enabled: 1,
      },
      isEdit: false,
      viewDialogVisible: false,
      viewRow: {},
      varietyOptionsDia: [],
      growthStageOptions: [], // 新增生长时期选项
    };
  },
  computed: {
    ...mapState('farm', ['greenhouseOptions', 'varietyOptions', 'stageOptions']),
  },
  created() {
    this.fetchData();
    this.fetchVarietyOptions();
  },
  methods: {
    async fetchData() {
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          greenhouseId: this.greenhouseId,
          varietyId: this.varietyId,
          basicStageId: this.basicStageId,
        };
        const res = await axios.post(baseUrl + '/api/digital-farming/growth-cycle/list-page', params);
        if (res.code === 200) {
          this.tableData = res.data.list || [];
          this.totalCount = parseInt(res.data.totalCount) || 0;
        }
      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },

    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleSearch() {
      this.page = 1;
      this.fetchData();
    },
    handleCreate() {
      this.isEdit = false;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.formData = {
          id: '',
          greenhouseId: '',
          greenhouseName: '',
          varietyId: '',
          varietyName: '',
          details: [],
          enabled: 1,
        };
      });
    },
    handleEdit(row) {
      this.isEdit = true;
      this.formData = {
        ...row,
        details: row.details || [],
      };
      this.dialogVisible = true;
    },
    handleView(row) {
      this.viewRow = { ...row };
      this.viewDialogVisible = true;
    },
    handleDialogClose() {
      this.isEdit = false;
      this.formData = {
        id: null,
        greenhouseId: '',
        greenhouseName: '',
        varietyId: '',
        varietyName: '',
        details: [],
        enabled: 1,
      };
    },
    handleDialogSuccess() {
      this.dialogVisible = false;
      this.fetchData();
    },
    async handleBatchDelete() {
      if (!this.selectedRows.length) return;
      try {
        await this.$confirm(`确认删除选中的 ${this.selectedRows.length} 个配置吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        const ids = this.selectedRows.map((row) => row.id);
        const res = await axios.post(baseUrl + '/api/digital-farming/growth-cycle/delete-batch', ids);
        if (res.code === 200) {
          this.$message.success('删除成功');
          this.fetchData();
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error);
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
    formatTime(time) {
      if (!time) return '';
      const date = new Date(time);
      return date
        .toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })
        .replace(/\//g, '/');
    },
    // 获取草莓品种选项
    async fetchVarietyOptions() {
      try {
        const res = await axios.post(baseUrl + '/api/farming/growth-stage-config/list-all', {
          enabled: 1,
        });
        if (res.code === 200) {
          this.varietyOptionsDia = res.data.map((item) => ({
            label: item.varietyName,
            value: item.varietyId,
            configDetails: item.configDetails,
          }));
        }
      } catch (error) {
        console.error('获取品种选项失败:', error);
      }
    },
    // 获取生长时期选项
  },
};
</script>

<style scoped lang="less">
.grow-up-container {
  width: calc(100vw - 20px);

  .page-content {
    box-sizing: border-box;
    background: rgba(0, 11, 47, 0.3);
    padding: 20px;
    border-radius: 4px;

    .operation-bar {
      margin-bottom: 20px;
      display: flex;
      align-items: center;

      .search-box {
        margin-left: auto;
        display: flex;
        align-items: center;
      }
    }

    .pagination-container {
      margin-top: 20px;
      text-align: right;
    }

    .period-hint {
      margin-bottom: 15px;
      padding: 10px;
      background-color: #fef0f0;
      border-radius: 4px;
    }

    .config-table {
      .add-button-container {
        margin-top: 15px;
        text-align: center;
        padding: 15px;
        border: 2px dashed #dcdfe6;
        border-radius: 4px;
        background-color: #fafafa;
      }
    }
  }
}

// 查看弹窗样式
.view-dialog-content {
  .filter-section {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 20px;
    padding: 15px;
    background: rgba(0, 11, 47, 0.1);
    border-radius: 4px;

    .filter-item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .filter-label {
        color: #fff;
        font-size: 12px;
        margin-bottom: 5px;
      }
    }
  }

  .basic-info {
    margin-bottom: 20px;

    .info-row {
      display: flex;
      gap: 20px;

      .info-item {
        flex: 1;
        display: flex;
        flex-direction: column;

        .info-label {
          color: #fff;
          font-size: 14px;
          margin-bottom: 8px;
          font-weight: 500;
        }

        .info-display {
          padding: 8px 12px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 4px;
          color: #fff;
          min-height: 32px;
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .existing-data {
    margin-bottom: 20px;

    .data-title {
      color: #fff;
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 10px;
    }
  }

  .period-hint {
    margin-bottom: 15px;
    padding: 10px;
    background-color: #fef0f0;
    border-radius: 4px;
  }

  .config-table {
    margin-bottom: 20px;
  }

  .status-info {
    display: flex;
    align-items: center;
    gap: 10px;

    .status-label {
      color: #fff;
      font-size: 14px;
      font-weight: 500;
    }

    .status-value {
      color: #04ff9f;
      font-size: 14px;
      padding: 4px 12px;
      background: rgba(4, 255, 159, 0.1);
      border-radius: 4px;
    }
  }
}

// 添加错误状态样式
:deep(.is-error) {
  .el-input__inner {
    border-color: #f56c6c !important;
  }
}
</style>
